import { Component, ElementRef, Input, OnInit, QueryList, ViewChildren } from '@angular/core';
import { Cards, Players, PokerService, RealPlayers } from '../../poker.service';
import { delay } from 'src/app/shared/utilities';

@Component({
  selector: 'app-hand-cards',
  templateUrl: './hand-cards.component.html',
  styleUrls: ['./hand-cards.component.css']
})
export class HandCardsComponent implements OnInit {
  @Input()
  set player(p:Players){
    this._player = p;
    p.handComp = this;
  }
  get player():Players{
    return this._player;
  }
  _player:Players;
  /** 上右下左 */
  @Input()
  seat:1|2|3|4
  @ViewChildren('cardEl')
  cardEls:QueryList<ElementRef< HTMLDivElement>>;
  constructor(private GM:PokerService) { }

  ngOnInit(): void {
    this.player.handComp = this;
  }
  onCardClick(card:Cards){
    if(this.GM.userPlayer.WaitingAction !=='Waiting'){
      return;
    }
    if(this.GM.gameMode=='PG'){
      this.GM.pickCard(this.GM.userPlayer,this.player,card);
    }
    if(this.GM.gameMode=='99'){
      if(this.player!=this.GM.userPlayer){
        return;
      }
      if(!this.GM.checkCard(card,'plus')){
        this.player.msg = '這張會輸'
        setTimeout(() => {
          this.player.msg = ''
        }, 1000);
        return;
      }
      this.GM.userPlayer.RunningAction()
      this.GM.throwCard(this.player,card,'plus');
    }
  }
  
  onCardRightClick(card:Cards){
    if(this.GM.userPlayer.WaitingAction !=='Waiting'){
      return;
    }
    if(this.GM.gameMode=='99'){
      if(this.player!=this.GM.userPlayer || card.no<=10){
        return;
      }
      if(!this.GM.checkCard(card,'minus')){
        this.player.msg = '這張會輸'
        setTimeout(() => {
          this.player.msg = ''
        }, 1000);
        return;
      }
      this.GM.userPlayer.RunningAction()
      this.GM.throwCard(this.player,card,'minus');
    }
    //this.moveTo(null,card)
  }
  evtBind:(e: TransitionEvent)=>void = null;
  getOffset(el:HTMLElement){
    var left = 0;
    var top = 0;
    var e = el;
    while(e.id!='poke-desk'){
      left+=e.offsetLeft;
      top+=e.offsetTop;
      e = e.offsetParent as HTMLElement;
    }
    return {left,top}
  }
  async moveTo(player:Players,card:Cards){
    var el = this.cardEls.find(x=>x.nativeElement.attributes.getNamedItem('name').value == card.text).nativeElement;
    var pos = this.getOffset(el);
    var left = pos.left;
    var top = pos.top;
    if(player==null){
      var rx = 270 -left;
      var ry = 254 - top;
      await new Promise<void>(async (rs,rj)=>{
        card.isOpen = true;
        var tEnd = ((e: TransitionEvent) => {
          console.log(`Card ${card.text} Move to transision end`)
          if (e.propertyName === 'transform') {
            el.removeEventListener('transitionend', tEnd);
            console.log(`Card ${card.text} Move to desk Done`)
            setTimeout(() => {
              rs();  
            }, 250);
          }
        });
        el.addEventListener('transitionend',tEnd);
        requestAnimationFrame(() => {
          console.log(`Card ${card.text} Move to desk Start`)
          el.style.transform = `translate(${rx}px,${ry}px)`
        });
      })
    }else{
      var tar = player.handComp.cardEls.last.nativeElement;
      var p2 = this.getOffset(tar);
      var tarLeft = p2.left + 20;
      var tarTop =  p2.top;
      var rotate = false;
      if(player.seat==1){ 
        tarTop+=80; 
      }
      if(player.seat==2){ 
        tarLeft-=100; 
        rotate = true;
      }
      if(player.seat==3){
         tarTop-=80; 
      }
      if(player.seat==4){ 
        tarLeft+=100; 
        rotate = true;
      }
      var rx = tarLeft - left;
      var ry = tarTop - top;
      await new Promise<void>((rs,rj)=>{
        const onTransitionEnd1 = (e: TransitionEvent) => {
          if (e.propertyName === 'transform') {
            el.removeEventListener('transitionend', onTransitionEnd1);
            console.log(`Card ${card.text} Move to ${player.name} Done`) 
            if(player instanceof RealPlayers){
              card.isOpen = true;
            }else{
              card.isOpen = false;
            }
            setTimeout(() => {
              rs();  
            }, 250);
          }
        };
        el.addEventListener('transitionend',onTransitionEnd1)
        console.log(`Card ${card.text} Move to ${player.name} Start`)
        el.style.transform = `translate(${rx}px,${ry}px) rotate(${rotate?'90deg':'0deg'})`
      })
    }
  }
  giveup(player:RealPlayers){
    player.ActionDone(true);
  }
}
